import React from 'react';

import UserPresenter from '../../../../../../presenters/UserPresenter';
import Group from '../../../../../../components/Group';
import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import Value from '../../../../../../components/Value';
import appRoutes from '../../../../../../routes/appRoutes';

const UserInfo = (props) => {
  const { user } = props;

  const auth0Id = UserPresenter.auth0Id(user);

  return (
    <Group title="User Info">
      <Row>
        <Column>
          <Value attr="fullName" title="Full Name">
            {UserPresenter.fullName(user)}
          </Value>
        </Column>
        <Column>
          <Value attr="userInfo" title="Email/Auth0">
            <div>{UserPresenter.email(user)}</div>
            <a
              href={appRoutes.userFastCashPath({ byAuth0Id: auth0Id })}
              target="_blank"
            >
              {auth0Id}
            </a>
          </Value>
        </Column>
        <Column>
          <Value attr="phoneNumber" title="Phone Number">
            {UserPresenter.phoneNumberReadable(user)}
          </Value>
        </Column>
      </Row>
    </Group>
  );
};

export default UserInfo;

UserInfo.propTypes = {
  user: UserPresenter.shape().isRequired,
};
